import { useEffect, useState } from "react"
import Radar from 'radar-sdk-js'
import { Business } from "@/api/interface/business"
// @ts-ignore
import cTz from 'countries-and-timezones'
import usePublicBusiness from "./api-hooks/usePublicBusiness"

const getCountryISOFromBrowserLang = (langCode: string) => {
  const hasISO = langCode.includes('-')

  if (hasISO) {
    const split = langCode.split('-')
    return split[1].toLowerCase()
  }
  return null
}

const usePublicBusinessCountry = (businessId: Business['id'], isSci?: boolean) => {
  // 1. country from radar
  // 2. country from browser language
  // 3. country from timezone
  // 4. country from business

  const [countryISO, setCountryISO] = useState(null)
  const { business } = usePublicBusiness(businessId)

  useEffect(() => {
    const getCountryISO = async () => {
      if (!isSci) {
        Radar.initialize(process.env.NEXT_PUBLIC_RADAR_PUBLISHABLE_KEY)
  
        Radar.ipGeocode((err, result) => {
          if (err) {
            console.error(err)
            return
          }
          if (result && result.address) {
            setCountryISO(result.address.countryCode?.toLowerCase())
          }
        })
      
      
        if (!countryISO) {
          setCountryISO(getCountryISOFromBrowserLang(navigator?.language))
        }
        if (!countryISO) {
          const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
          const countriesFromTz = cTz.getCountriesForTimezone(tz)
          if (countriesFromTz?.length === 1) {
            setCountryISO(countriesFromTz[0]?.id?.toLowerCase())
          }
        }
      }
      if (!countryISO) {
        setCountryISO(business?.address?.country?.toLowerCase())
      }
      if (!countryISO) {
        setCountryISO('us')
      }
    }
    getCountryISO()
    
  }, [countryISO, business])

  return { countryISO }
}

export default usePublicBusinessCountry